import { axiosInstance } from '../../../../network/apis';
import { endpoints, ID } from '../../../../_metronic/constants/paths';

export const companyLogs = endpoints.companyLogs;

export function getLogList({ companyId, params }: { companyId: ID; params?: any }) {
  return axiosInstance.get(companyLogs(companyId), { params });
}
